import { request, success, failure, DEPARTMENTS, DEPARTMENT_TASK_CATEGORY } from "./utilities";
import { getDepartmentList, addNewDepartment, deleteDepartment } from "../api";
import { APP_SETTINGS } from "../../config";
import { GetRequest, PostRequest } from '../api/genericApiCalls'


export function getAllCategories(deptId, token) {
    return (dispatch) => {
        dispatch(request(DEPARTMENT_TASK_CATEGORY.GET_CATEGORIES_REQUEST));
        var path = `${APP_SETTINGS.API_PATH.DEPARTMENT_TASK_CATEGORIES.getCategories}?departmentId=${deptId}`
        PostRequest(path, null, token).then((res) => {
            if (res.data.status === 1) {
                dispatch(success(DEPARTMENT_TASK_CATEGORY.GET_CATEGORIES_SUCCESS, res.data.data));
            }
            else {
                dispatch(failure(DEPARTMENT_TASK_CATEGORY.GET_CATEGORIES_FAILURE, res.data.message));
            }
        }, (error) => {
            dispatch(failure(DEPARTMENT_TASK_CATEGORY.GET_CATEGORIES_FAILURE, (error && error.response && error.response.data && error.response.data.title ? error.response.data.title : error.message)))
        })
    }
}

export function addCategory(deptData, token, operationSuccesded, operationError) {
    return (dispatch) => {
        dispatch(request(DEPARTMENT_TASK_CATEGORY.ADD_CATEGORY_REQUEST));
        var path = APP_SETTINGS.API_PATH.DEPARTMENT_TASK_CATEGORIES.saveCategory
        PostRequest(path, deptData, token).then((res) => {
            if (res.data.status === 1) {
                dispatch(success(DEPARTMENT_TASK_CATEGORY.ADD_CATEGORY_SUCCESS, res.data.data));
                if (operationSuccesded) {
                    operationSuccesded();
                }
            }
            else {
                dispatch(success(DEPARTMENT_TASK_CATEGORY.ADD_CATEGORY_FAILURE, res.data.message));
            }
        }, (error) => {
            dispatch(failure(DEPARTMENT_TASK_CATEGORY.ADD_CATEGORY_FAILURE, (error && error.response && error.response.data && error.response.data.title ? error.response.data.title : error.message)))
            if (operationError){
                operationError(error.message);
            }
            
        })
    }
}

export function editCategory(deptData, token, operationSuccesded) {
    return (dispatch) => {
        dispatch(request(DEPARTMENT_TASK_CATEGORY.EDIT_CATEGORY_REQUEST));
        var path = APP_SETTINGS.API_PATH.DEPARTMENT_TASK_CATEGORIES.saveCategory
        PostRequest(path, deptData, token).then((res) => {
            if (res.data.status === 1) {
                dispatch(success(DEPARTMENT_TASK_CATEGORY.EDIT_CATEGORY_SUCCESS, res.data.data));
                if (operationSuccesded) {
                    operationSuccesded();
                }
            }
            else {
                dispatch(success(DEPARTMENT_TASK_CATEGORY.EDIT_CATEGORY_FAILURE, res.data.message));
            }
        }, (error) => {
            dispatch(failure(DEPARTMENT_TASK_CATEGORY.EDIT_CATEGORY_FAILURE, (error && error.response && error.response.data && error.response.data.title ? error.response.data.title : error.message)))
        })
    }
}

export function removeCategory(info, token, close) {
    return (dispatch) => {
        dispatch(request(DEPARTMENT_TASK_CATEGORY.DELETE_CATEGORY_REQUEST));
        var path = `${APP_SETTINGS.API_PATH.DEPARTMENT_TASK_CATEGORIES.deleteCategory}?id=${info.taskCategoryId}`;
        PostRequest(path, null, token).then((res) => {
            if (res.data.status === 1) {
                dispatch(success(DEPARTMENT_TASK_CATEGORY.DELETE_CATEGORY_SUCCESS, res.data.data, info));
                if (close) {
                    close();
                }
            }
            else {
                dispatch(failure(DEPARTMENT_TASK_CATEGORY.DELETE_CATEGORY_FAILURE, res.data.message));
            }
        }, (error) => {
            dispatch(failure(DEPARTMENT_TASK_CATEGORY.DELETE_CATEGORY_FAILURE, (error && error.response && error.response.data && error.response.data.title ? error.response.data.title : error.message)))
        })
    }
}

export function getTaskCategoriesSelectListAction(employeeId,token) {
    return (dispatch) => {
        dispatch(request(DEPARTMENT_TASK_CATEGORY.GET_CATEGORIES_SELECTLIST_REQUEST));
        var path = `${APP_SETTINGS.API_PATH.DEPARTMENT_TASK_CATEGORIES.getCategoriesSelectList}?employeeId=${employeeId}`;
        PostRequest(path, null, token).then((res) => {
            if (res.data.status === 1) {
                dispatch(success(DEPARTMENT_TASK_CATEGORY.GET_CATEGORIES_SELECTLIST_SUCCESS, res.data.data));
            }
            else {
                dispatch(failure(DEPARTMENT_TASK_CATEGORY.GET_CATEGORIES_SELECTLIST_FAILURE, res.data.message));
            }
        }, (error) => {
            dispatch(failure(DEPARTMENT_TASK_CATEGORY.GET_CATEGORIES_SELECTLIST_FAILURE, (error && error.response && error.response.data && error.response.data.title ? error.response.data.title : error.message)))
        })
    }
}